module.exports = __webpack_public_path__ + "static/media/SuiteN03.b091306c.jpg";